module.exports = __webpack_public_path__ + "img/agreement.578178dc.svg";